module.exports = __webpack_public_path__ + "static/media/airconditioner_heat.cd9f6b01.png";